<template>
  <div class="header-notifications-box">
    <div @click="goTo()" :to="link" class="header-notifications-box-inner">
      <p>{{item.title}}</p>
      <p class="header-notifications-body">{{item.body}}</p>
      <span class="header-notifications-date">{{notification.createdAt | formatDate2}}</span>
    </div>
  </div>
<!--  <div class="header-notifications-box">-->
<!--    <div class="header-notifications-img">-->
<!--      <img src="../../assets/images/pic-person.jpg">-->
<!--    </div>-->
<!--    <div class="header-notifications-box-inner">-->
<!--      <p>Jurrien Oldhof voted for your idea: Welcome boxes for New Joiners.</p>-->
<!--      <span class="header-notifications-date">Dec 10, 2020</span>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
import api from '@/api/notification'
export default {
name: "NotificationItem",
props: ['notification'],
computed: {
  item() {
    return this.notification._embedded.Notification
  },
  link() {
    if(this.item.contentCode === 'NEWSFORYOU') {
      return `/${this.$route.params.companySlug}/news/${this.item.idNews}`
    }
    if(this.item.contentCode === 'GENERAL') {
      return `/${this.$route.params.companySlug}/`
    }
    if(this.item.contentCode === 'AGENDA') {
      return `/${this.$route.params.companySlug}/agenda/${this.item.idAgendaEntry}`
    }
    if(this.item.contentCode === 'CLIENTS') {
      return `/${this.$route.params.companySlug}/clients/${this.item.idClient}`
    }
    if(this.item.contentCode === 'SOLUTIONSFORYOU') {
      return `/${this.$route.params.companySlug}/solutions/s/${this.item.idSolution}`
    }
    if(this.item.contentCode === 'MEETYOURTEAM') {
      return `/${this.$route.params.companySlug}/meet-your-team`
    }
    if(this.item.contentCode === 'WHATWEDOFORYOU') {
      return `/${this.$route.params.companySlug}/what-we-do-for-you`
    }
    return "/"
  }
},
methods: {
  goTo() {
    this.$router.push(this.link)
    api.deleteNotification(this.notification.idUserNotification, () => {
      this.$store.dispatch('getUserInfo', this.$store.getters.selectedCompanyId)
    })
  }
}
}
</script>

<style scoped>

</style>